import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-confirm-body',
  template: '<ng-content />',
  styleUrls: ['confirm-body.component.scss']
})
export class ConfirmBodyComponent {}
